export const fetchFirstAvailableMonth = (params) => (
  $.ajax({ type: "GET", url: "/first_available/month", data: params })
);

export const warmFirstAvailable = (params) => (
  $.ajax({ type: "POST", url: "/first_available/warm", data: params })
);

export const assignFirstAvailable = (params) => (
  $.ajax({ type: "POST", url: "/first_available/assign", data: params })
);

export const fetchFirstAvailableRotation = () => (
  $.ajax({ type: "GET", url: "/first_available/rotation" })
);

// A /book?photographer=<id> link locks that photographer in for this visit.
const PHOTOGRAPHER_KEY = "ma_book_photographer";
export const rememberBookPhotographer = () => {
  try {
    const id = new URLSearchParams(window.location.search).get("photographer");
    if (id && /^\d{1,10}$/.test(id)) sessionStorage.setItem(PHOTOGRAPHER_KEY, id);
  } catch (e) {}
};
export const bookPhotographer = () => {
  try { return sessionStorage.getItem(PHOTOGRAPHER_KEY); } catch (e) { return null; }
};
export const clearBookPhotographer = () => {
  try { sessionStorage.removeItem(PHOTOGRAPHER_KEY); } catch (e) {}
};
